/**
 * Work Management Service
 * Work tracking and management service API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssignWorkItemRequestDto { 
    /**
     * Assignment type
     */
    assignmentType: AssignWorkItemRequestDto.AssignmentTypeEnum;
    /**
     * Assignee ID (user ID, team ID, or role ID)
     */
    assigneeId: string;
    /**
     * Assignee display name
     */
    assigneeName: string;
    /**
     * Whether to cascade assignment to child work items
     */
    cascadeToChildren?: boolean;
}
export namespace AssignWorkItemRequestDto {
    export type AssignmentTypeEnum = 'user' | 'team' | 'role';
    export const AssignmentTypeEnum = {
        User: 'user' as AssignmentTypeEnum,
        Team: 'team' as AssignmentTypeEnum,
        Role: 'role' as AssignmentTypeEnum
    };
}


